import { A4PowerGrid, B1Battery, B4RemainingTime, J2Lock } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { DynamicEmsData, EmsBatteryMode } from 'src/Libs/dynamic-power-prices/types'

const useStyles = makeStyles()(theme => ({
  icon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
}))

interface Props {
  isDynamicEmsDataLoading: boolean
  dynamicEmsData: DynamicEmsData[]
}

/**
 * Component for a chart widget that shows the current ems battery type as subtitle
 */
const DynamicEmsWidgetSubtitle: React.FC<Props> = ({ dynamicEmsData, isDynamicEmsDataLoading }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  if (isDynamicEmsDataLoading) {
    return (
      <>
        <Typography variant="caption" noWrap>
          {t('systemSettings-dynamic-prices.battery.dynamic-ems.loading.title')}
        </Typography>
        <B4RemainingTime className={classes.icon} />
      </>
    )
  }

  const getEmsBatteryMode = (data: DynamicEmsData[]): EmsBatteryMode | null => {
    const currentTime = new Date()

    const currentData = data.find(item => {
      const startTime = new Date(item.start)
      const endTime = new Date(item.end)
      return currentTime >= startTime && currentTime <= endTime
    })

    if (currentData) {
      return currentData.emsBatteryMode
    }

    return null
  }

  if (getEmsBatteryMode(dynamicEmsData) === EmsBatteryMode.BlockDischarging) {
    return (
      <>
        <Typography variant="caption" noWrap>
          {t('dashboard.liveView.widgets.dynamic-power-price.legend.discharging-blocked')}
        </Typography>
        <J2Lock className={classes.icon} />
      </>
    )
  } else if (getEmsBatteryMode(dynamicEmsData) === EmsBatteryMode.GridCharge) {
    return (
      <>
        <Typography variant="caption" noWrap>
          {t('dashboard.liveView.widgets.dynamic-power-price.legend.charging-from-grid')}
        </Typography>
        <A4PowerGrid className={classes.icon} />
      </>
    )
  }

  return (
    <>
      <Typography variant="caption" noWrap>
        {t('dashboard.liveView.widgets.dynamic-power-price.legend.normal-operation')}
      </Typography>
      <B1Battery className={classes.icon} />
    </>
  )
}

export default DynamicEmsWidgetSubtitle
